/* ============================================================
   HARBOUR QUIZ — v30 RESULTS-CONTINUITY / BUILDER-OWNED IMAGES
   Quiz Kit remains the source of truth for all visible quiz
   content and interaction. This script only classifies and marks
   the native DOM so CSS can style it.
   ============================================================ */
(function(){
  if(window.__harbourQuizNativeV30Loaded) return;
  window.__harbourQuizNativeV30Loaded = true;

  var QUIZ_KEY = '7wlm0mNPW';
  var ROOT = '[data-quiz-kit-key="' + QUIZ_KEY + '"]';
  var timer = null;
  var selectedByQuestion = Object.create(null);
  var resizeObservers = [];
  var observedRoots = new WeakSet();

  function norm(value){
    return String(value || '')
      .replace(/\u00a0/g,' ')
      .replace(/[–—]/g,'-')
      .replace(/\s+/g,' ')
      .trim();
  }

  function text(el){
    return norm(el && (el.innerText || el.textContent));
  }

  function root(){
    return document.querySelector(ROOT);
  }

  function visible(el){
    if(!el || !el.getBoundingClientRect) return false;
    var rect = el.getBoundingClientRect();
    var style = getComputedStyle(el);
    return rect.width > 2 && rect.height > 2 &&
      style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function clearMarks(r){
    if(!r) return;
    [
      'data-harbour-design','data-harbour-layout','data-harbour-answer-count',
      'data-harbour-has-hero','data-harbour-final','data-harbour-repeated-images','data-harbour-responsive'
    ].forEach(function(attr){ r.removeAttribute(attr); });

    r.querySelectorAll([
      '[data-harbour-title]','[data-harbour-progress]','[data-harbour-question-shell]',
      '[data-harbour-answer-grid]','[data-harbour-answer-group]','[data-harbour-answer-choice]',
      '[data-harbour-selected]','[data-harbour-next]','[data-harbour-back]','[data-harbour-start]',
      '[data-harbour-nav]','[data-harbour-layout-shell]','[data-harbour-content-column]',
      '[data-harbour-hero-wrap]','[data-harbour-hero]','[data-harbour-intro-copy]',
      '[data-harbour-question-hero-wrap]'
    ].join(',')).forEach(function(el){
      Array.from(el.attributes).forEach(function(attr){
        if(attr.name.indexOf('data-harbour-') === 0) el.removeAttribute(attr.name);
      });
    });
  }

  function lca(nodes, stop){
    nodes = nodes.filter(Boolean);
    if(!nodes.length) return null;
    var node = nodes[0];
    while(node){
      var containsAll = true;
      for(var i=1;i<nodes.length;i++){
        if(!node.contains(nodes[i])){ containsAll = false; break; }
      }
      if(containsAll) return node;
      if(node === stop) break;
      node = node.parentElement;
    }
    return null;
  }

  function clickable(r, re){
    var nodes = r.querySelectorAll('button,a,[role="button"],input[type="button"],input[type="submit"]');
    var best = null;
    for(var i=0;i<nodes.length;i++){
      var el = nodes[i];
      if(!visible(el)) continue;
      var value = el.matches('input') ? String(el.value || el.getAttribute('aria-label') || '') : text(el);
      if(!re.test(value)) continue;
      if(!best || value.length < text(best).length) best = el;
    }
    return best;
  }

  function markNav(r){
    var next = r.querySelector('#quiz-kit-question-next-button') || clickable(r,/^next\b/i);
    var back = r.querySelector('#quiz-kit-question-back-button') || clickable(r,/^(?:←\s*)?back\b/i);
    var start = r.querySelector('#quiz-kit-intro-button') || clickable(r,/^start(?: the)? quiz/i);

    if(next) next.setAttribute('data-harbour-next','true');
    if(back) back.setAttribute('data-harbour-back','true');
    if(start) start.setAttribute('data-harbour-start','true');

    var nav = r.querySelector('#quiz-kit-question-navigation') || lca([next,back].filter(Boolean),r);
    if(nav && nav !== r) nav.setAttribute('data-harbour-nav','true');
    return {next:next,back:back,start:start,nav:nav};
  }

  function rawChoices(r){
    return Array.from(r.querySelectorAll('[id^="quiz-kit-question-multiple-choice-"]'))
      .filter(visible)
      .filter(function(choice){
        return !(choice.parentElement && choice.parentElement.closest('[id^="quiz-kit-question-multiple-choice-"]'));
      });
  }

  function firstSrcsetUrl(value){
    value = String(value || '').trim();
    if(!value) return '';
    var first = value.split(',')[0].trim();
    return first.split(/\s+/)[0] || '';
  }

  function imageSrc(img){
    if(!img) return '';

    /* Builder-owned Quiz Kit images can be lazy-populated. Do not rely only on
       currentSrc/src because below-the-fold answers may not have been promoted
       into those properties yet. Read every native lazy-source shape Quiz Kit
       can expose, including <picture><source>. */
    var direct = [
      img.currentSrc,
      img.getAttribute('src'),
      img.getAttribute('data-src'),
      img.getAttribute('data-lazy-src')
    ].map(function(v){ return String(v || '').trim(); }).filter(Boolean);
    if(direct.length) return direct[0];

    var sets = [
      img.getAttribute('srcset'),
      img.getAttribute('data-srcset'),
      img.getAttribute('data-lazy-srcset')
    ];
    var picture = img.closest && img.closest('picture');
    if(picture){
      Array.from(picture.querySelectorAll('source')).forEach(function(source){
        sets.push(source.getAttribute('srcset'));
        sets.push(source.getAttribute('data-srcset'));
        sets.push(source.getAttribute('data-lazy-srcset'));
      });
    }
    for(var i=0;i<sets.length;i++){
      var candidate = firstSrcsetUrl(sets[i]);
      if(candidate) return candidate;
    }
    return '';
  }

  function nativeSelected(choice){
    if(!choice) return false;
    var candidates = [choice, choice.querySelector('button'), choice.querySelector('input')].filter(Boolean);
    for(var i=0;i<candidates.length;i++){
      var el = candidates[i];
      if(el.matches && el.matches('input:checked')) return true;
      if(el.getAttribute('aria-selected') === 'true' ||
         el.getAttribute('aria-pressed') === 'true' ||
         el.getAttribute('aria-checked') === 'true' ||
         el.getAttribute('data-selected') === 'true') return true;
      var cls = String(el.className || '');
      if(/(^|\s)(selected|active|checked)(\s|$)/i.test(cls)) return true;
    }
    return false;
  }

  function questionKey(r, title){
    var wrapper = title && (title.closest('[id^="quiz-kit-question-wrapper-"]') || title.closest('[id^="quiz-kit-question-"]'));
    return (wrapper && wrapper.id) || (title && title.id) || text(title) || 'question';
  }

  function markChoices(r, title, choices){
    var qKey = questionKey(r,title);
    var stored = selectedByQuestion[qKey];
    var nativeChoice = null;

    choices.forEach(function(choice){
      choice.setAttribute('data-harbour-answer-choice','true');
      var nativeImg = choice.querySelector('img');
      var imageContainer = choice.querySelector('.quiz-kit-image-container');

      /* Quiz Kit is the source of truth for answer imagery. If its renderer
         supplies image markup, keep that markup eligible to load even when the
         image is below the fold and src/currentSrc have not been populated yet.
         The Harbour layer never inserts answer placeholder images. */
      if(nativeImg || imageContainer){
        choice.setAttribute('data-harbour-has-image','true');
        if(imageContainer) imageContainer.setAttribute('data-harbour-real-image','true');
      } else {
        choice.removeAttribute('data-harbour-has-image');
      }
      if(nativeImg){
        nativeImg.removeAttribute('aria-hidden');
        nativeImg.setAttribute('loading','eager');
        nativeImg.setAttribute('decoding','async');
      }
      if(nativeSelected(choice)) nativeChoice = choice;
      if(!choice.__harbourNativeV18Bound){
        choice.__harbourNativeV18Bound = true;
        choice.addEventListener('click',function(){
          selectedByQuestion[qKey] = choice.id || text(choice);
          choices.forEach(function(c){ c.removeAttribute('data-harbour-selected'); });
          choice.setAttribute('data-harbour-selected','true');
          schedule();
          setTimeout(decorate,80);
          setTimeout(decorate,220);
        },{passive:true});
      }
    });

    if(nativeChoice) selectedByQuestion[qKey] = nativeChoice.id || text(nativeChoice);
    var selectedId = selectedByQuestion[qKey] || stored;
    choices.forEach(function(choice){
      choice.removeAttribute('data-harbour-selected');
      if(selectedId && selectedId === (choice.id || text(choice))) choice.setAttribute('data-harbour-selected','true');
    });

    var grid = choices[0] && choices[0].closest('[id^="quiz-kit-question-grid-"]');
    if(grid) grid.setAttribute('data-harbour-answer-grid','true');

    var group = lca(choices,r);
    if(group && group !== r) group.setAttribute('data-harbour-answer-group','true');

    r.setAttribute('data-harbour-answer-count',String(choices.length));
    return {grid:grid,group:group};
  }

  function findQuestionHero(r, choices){
    var choiceSet = new Set(choices);
    var images = Array.from(r.querySelectorAll('img')).filter(function(img){
      if(!visible(img)) return false;
      var choice = img.closest('[id^="quiz-kit-question-multiple-choice-"]');
      return !choice || !choiceSet.has(choice);
    });
    if(!images.length) return null;
    images.sort(function(a,b){
      var ar = a.getBoundingClientRect(), br = b.getBoundingClientRect();
      return (br.width * br.height) - (ar.width * ar.height);
    });
    return images[0];
  }

  function classifyLayout(r, choices, hero){
    var imgs = choices.map(function(choice){ return choice.querySelector('img'); });
    var hasAnyImages = imgs.some(Boolean) || choices.some(function(choice){
      return !!choice.querySelector('.quiz-kit-image-container');
    });
    var srcs = imgs.filter(Boolean).map(imageSrc).filter(Boolean);
    var repeated = srcs.length > 1 && new Set(srcs).size === 1;

    /* Builder-first rule inherited from the Ooni production implementation:
       if Quiz Kit supplies an answer image container or image node, keep it.
       Repeated image URLs can be intentional and must never cause builder-owned
       imagery to be hidden. */
    if(repeated) r.setAttribute('data-harbour-repeated-images','true');

    if(hero) return 'editorial-split';
    if(hasAnyImages) return 'visual';
    return 'text';
  }

  function markProgress(r){
    var candidates = Array.from(r.querySelectorAll('#quiz-kit-container > h3,[id^="quiz-kit-question-wrapper-"] h3,h3')).filter(visible);
    var progress = null, current = 0, total = 0;
    candidates.forEach(function(el){
      var match = text(el).match(/(?:question\s+)?(\d+)\s*(?:of|\/)\s*(\d+)/i);
      if(match && (!progress || el.children.length < progress.children.length)){
        progress = el;
        current = parseInt(match[1],10);
        total = parseInt(match[2],10);
      }
    });
    if(progress){
      progress.setAttribute('data-harbour-progress','true');
      progress.style.setProperty('--harbour-progress-ratio',String(total ? current / total : 0));
      if(total && current === total) r.setAttribute('data-harbour-final','true');
    }
    return progress;
  }

  function markIntro(r){
    r.setAttribute('data-harbour-layout','intro');

    var intro = r.querySelector('#quiz-kit-intro');
    var title = r.querySelector('#quiz-kit-intro-title');
    var copy = r.querySelector('#quiz-kit-intro-text');
    var heroWrap = r.querySelector('#quiz-kit-intro-content-image');
    var hero = heroWrap && heroWrap.querySelector('img');
    var nav = markNav(r);

    if(title) title.setAttribute('data-harbour-title','true');
    if(copy) copy.setAttribute('data-harbour-intro-copy','true');
    if(heroWrap) heroWrap.setAttribute('data-harbour-hero-wrap','true');
    if(hero){
      hero.setAttribute('data-harbour-hero','true');
      /* The intro hero is above the fold. Preserve Quiz Kit's exact image URL,
         request it eagerly, and also use that same builder-owned URL as a
         background fallback. Some mobile WebViews can leave Quiz Kit's image
         element in its placeholder state after responsive reflow. */
      try{
        var heroSrc = String(hero.currentSrc || hero.src || hero.getAttribute('src') || '');
        hero.setAttribute('loading','eager');
        hero.setAttribute('fetchpriority','high');
        hero.style.setProperty('opacity','1','important');
        hero.style.setProperty('visibility','visible','important');
        if(heroWrap && heroSrc && heroWrap.getAttribute('data-harbour-hero-src') !== heroSrc){
          heroWrap.setAttribute('data-harbour-hero-src', heroSrc);
          heroWrap.style.setProperty('background-image','url(\"' + heroSrc.replace(/\"/g,'') + '\")','important');
          heroWrap.style.setProperty('background-size','cover','important');
          heroWrap.style.setProperty('background-position','center','important');
          heroWrap.style.setProperty('background-repeat','no-repeat','important');
          var preloader = new Image();
          preloader.decoding = 'async';
          preloader.src = heroSrc;
          if(hero.decode) hero.decode().catch(function(){});
        }
      }catch(e){}
    }

    var shell = intro && intro.parentElement;
    if(shell && heroWrap && shell.contains(heroWrap)) shell.setAttribute('data-harbour-layout-shell','true');
    else {
      shell = lca([intro,heroWrap].filter(Boolean),r);
      if(shell && shell !== r) shell.setAttribute('data-harbour-layout-shell','true');
    }

    var content = intro && intro.querySelector('#quiz-kit-container');
    if(content) content.setAttribute('data-harbour-content-column','true');

    /* Quiz Kit's transparent intro overlay can intercept pointer events in some themes.
       Disable hit testing only; do not replace or proxy the native Start button. */
    var overlay = r.querySelector('#quiz-kit-intro-overlay');
    if(overlay){
      overlay.style.setProperty('pointer-events','none','important');
      overlay.style.setProperty('z-index','0','important');
      overlay.setAttribute('aria-hidden','true');
    }
    if(nav.start){
      nav.start.style.setProperty('pointer-events','auto','important');
      nav.start.style.setProperty('position','relative','important');
      nav.start.style.setProperty('z-index','5','important');
    }
  }

  function markQuestion(r){
    var title = Array.from(r.querySelectorAll('[id^="quiz-kit-question-title-"]')).find(visible);
    if(!title) return;
    title.setAttribute('data-harbour-title','true');

    var choices = rawChoices(r);
    var hero = findQuestionHero(r,choices);
    var layout = classifyLayout(r,choices,hero);
    r.setAttribute('data-harbour-layout',layout);
    r.setAttribute('data-harbour-has-hero',hero ? 'true' : 'false');

    var wrapper = title.closest('[id^="quiz-kit-question-wrapper-"]') || title.closest('[id^="quiz-kit-question-"]');
    if(wrapper) wrapper.setAttribute('data-harbour-question-shell','true');

    if(hero){
      hero.setAttribute('data-harbour-hero','true');
      var wrap = hero.closest('#quiz-kit-question-image') || hero.parentElement;
      if(wrap) wrap.setAttribute('data-harbour-question-hero-wrap','true');
    }

    markProgress(r);
    markChoices(r,title,choices);
    markNav(r);
  }

  function setResponsive(r){
    if(!r || !r.getBoundingClientRect) return;
    var rect = r.getBoundingClientRect();
    var width = Math.round(rect.width || r.clientWidth || window.innerWidth || 0);
    var mode = width <= 1024 ? 'stacked' : (width <= 1240 ? 'compact' : 'wide');
    r.setAttribute('data-harbour-responsive',mode);
    r.style.setProperty('--harbour-root-width',String(width));
  }

  function observeResponsive(r){
    if(!r || observedRoots.has(r) || !window.ResizeObserver) return;
    observedRoots.add(r);
    var ro = new ResizeObserver(function(){ setResponsive(r); });
    ro.observe(r);
    resizeObservers.push(ro);
  }

  function decorate(){
    var r = root();
    if(!r){
      document.body.classList.remove('harbour-quiz-active');
      return;
    }

    document.body.classList.add('harbour-quiz-active');
    /* Do not tear down and rebuild every data marker on each mutation.
       Quiz Kit replaces question nodes as it navigates, so idempotent marking
       is enough and avoids mobile main-thread churn. */
    r.setAttribute('data-harbour-design','v30-native');

    var introTitle = r.querySelector('#quiz-kit-intro-title');
    if(introTitle && visible(introTitle)) markIntro(r);
    else markQuestion(r);

    setResponsive(r);
    observeResponsive(r);
  }

  function schedule(){
    clearTimeout(timer);
    timer = setTimeout(decorate,16);
  }

  document.addEventListener('quizKitQuestionLoaded',function(){
    schedule();
    setTimeout(decorate,160);
    setTimeout(decorate,420);
  },false);

  document.addEventListener('click',function(event){
    if(event.target && event.target.closest && event.target.closest(ROOT)){ schedule(); setTimeout(decorate,120); }
  },true);

  document.addEventListener('load',function(event){
    var target = event.target;
    if(target && target.tagName === 'IMG' && target.closest && target.closest(ROOT)){
      schedule();
      setTimeout(decorate,80);
    }
  },true);

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',schedule);
  else schedule();

  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('orientationchange',schedule,{passive:true});

  var quizObserver = null;
  var mountObserver = null;

  function attachQuizObserver(){
    var r = root();
    if(!r || quizObserver) return !!r;
    quizObserver = new MutationObserver(function(mutations){
      var shouldDecorate = mutations.some(function(m){
        if(m.type === 'childList') return true;
        return ['class','aria-selected','aria-pressed','aria-checked','checked','disabled','src','srcset','data-src','data-srcset','style'].indexOf(m.attributeName) !== -1;
      });
      if(shouldDecorate) schedule();
    });
    quizObserver.observe(r,{
      childList:true,
      subtree:true,
      attributes:true,
      attributeFilter:['class','aria-selected','aria-pressed','aria-checked','checked','disabled','src','srcset','data-src','data-srcset','style']
    });
    return true;
  }

  if(!attachQuizObserver()){
    mountObserver = new MutationObserver(function(){
      if(attachQuizObserver()){
        mountObserver.disconnect();
        mountObserver = null;
        schedule();
      }
    });
    mountObserver.observe(document.documentElement,{childList:true,subtree:true});
  }


  setTimeout(decorate,300);
  setTimeout(decorate,900);
  setTimeout(decorate,1800);

  try{ console.info('[Harbour Quiz v41] builder-owned answer images preserved across lazy loading'); }catch(e){}
})();
